module.exports = __webpack_public_path__ + "img/jieping.de7f398d.png";